export interface UsageMapping {
  ui: string;
  backend: string;
}

export const MONTH_TO_DATE: UsageMapping = { backend: "MONTH_TO_DATE", ui: "By Month" };
export const YEAR_TO_DATE: UsageMapping = { backend: "YEAR_TO_DATE", ui: "By Year" };

export const USAGE_MAPPINGS: UsageMapping[] = [MONTH_TO_DATE, YEAR_TO_DATE];
